import React from 'react'

const TeamsAndConditions = () => {
  return (
    <div>TeamsAndConditions</div>
  )
}

export default TeamsAndConditions